import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '@/supabaseClient';

export function useUserWithDbId() {
  const { user: authUser, loading: authLoading, session, signOut } = useAuth();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserDbId = async () => {
      if (authLoading) {
        return;
      }

      if (!authUser) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        const { data: { session } } = await supabase.auth.getSession();
        
        const response = await fetch('/api/user-id', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session?.access_token}`,
            'Content-Type': 'application/json',
          }
        });

        if (!response.ok) {
          // Handle authentication errors
          if (response.status === 401 || response.status === 403) {
            console.warn('Authentication error in user ID fetching, signing out user');
            try {
              await signOut();
              return;
            } catch (signOutError) {
              console.error('Error signing out user:', signOutError);
            }
          }
          throw new Error('Failed to fetch user ID');
        }

        const { userId } = await response.json();

        setUser({
          ...authUser,
          dbUserId: userId
        });
      } catch (error) {
        console.error('Error fetching user database ID:', error);
        // Fallback to user without database ID
        setUser(authUser);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDbId();
  }, [authUser, authLoading]);

  return {
    user,
    loading,
    session,
    signOut,
  };
} 